// 导入axios
import axios from 'axios';
import qs from 'qs'

// 进行一些全局配置
// 公共路由(网络请求地址)
// export const baseURL = 'http://192.200.200.86:9800/';
// export const baseURL = 'https://www.topo360.com/topo2/ent';

// 进行一些全局配置
export let baseURL;

// // 公共路由(网络请求地址)
if (process.env.NODE_ENV === 'production') {
  baseURL = VUE_APP_URL.baseUrl;
} else {
  // baseURL = 'https://www.topo360.com/topo2/ent';
  baseURL = 'http://localhost:9800/zqy/';
  // baseURL = 'http://192.200.200.102:9800/';
}
// 请求响应超时时间
axios.defaults.timeout = 30000;

var asyncStatue = true;

// 封装接口请求
export function request(methodType,requestUrl,asyncStatue,param) {
  return axios({
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      // 'token': localStorage.getItem('token')
    },
    url: requestUrl,
    method: methodType,
    data: qs.stringify(param),
    asyncStatue: asyncStatue
  })
}